import React from "react";
import './style.less'
import { Carousel, Row,Col } from 'antd';

export default class JoinUs extends React.Component {
    componentDidMount() {
        // setInterval(function() {
        //     const show = document.querySelector('span[data-show]')
        //     const next = show.nextElementSibling || document.querySelector('span:first-child')
        //     const up = document.querySelector('span[data-up]')
        //     if (up) {
        //         up.removeAttribute('data-up')
        //     }
        //     show.removeAttribute('data-show')
        //     show.setAttribute('data-up', '')
        
        //     next.setAttribute('data-show', '')
        // }, 2000)
    }
    render() {
    
        return (
            <div className="join-us">
                <div className="title">
                    <Row className="words" justify="center">
                        <Col span={12} className="find">找到你的</Col>
                        <Col  span={12} className="rollInfo">
                            <Carousel dotPosition={"left"} dots={false} autoplay>
                                <div>
                                    <h3>组织</h3>
                                </div>
                                <div>
                                    <h3>使命</h3>
                                </div>
                                <div>
                                    <h3>未来</h3>
                                </div>
                            </Carousel>
                        </Col>
                    </Row>
                </div>

                <div className="find-us">
                    <h2>加入我们： hr@metridynamic.com</h2>
                </div>
            </div>
        )
    }
}